import { TDataViewProps } from '@/types/TSmartCRM';
import { BOARD_CONFIG } from 'src/constants/smartCRM';
import { EViewType } from 'src/enums/ESmartCRM';
import { TableView } from './TableView';
import { BoardView } from './BoardView';

interface EnhancedDataViewProps extends TDataViewProps {
	isFilterView?: boolean;
	filterViewName?: string;
	customGroupNames?: string[];
	responseGroups?: Record<string, any[]>;
}

export const DataView = ({
	data,
	fields,
	view,
	loading = false,
	onCustomerAction,
	groupBy = BOARD_CONFIG.defaultGroupBy,
	pagination,
	deleteCustomer,
	isFilterView = false,
	filterViewName,
	customGroupNames,
	responseGroups,
}: EnhancedDataViewProps) => {
	const effectiveGroupBy =
		isFilterView && view === EViewType.BOARD
			? groupBy || (fields.length > 0 ? fields[0].internalKey : '')
			: groupBy;

	switch (view) {
		case EViewType.TABLE:
			return (
				<div>
					<TableView
						customers={data}
						fields={fields}
						loading={loading}
						onCustomerAction={onCustomerAction}
						pagination={pagination}
						deleteCustomer={deleteCustomer}
					/>
				</div>
			);

		case EViewType.BOARD:
			return (
				<div>
					<BoardView
						customers={data}
						fields={fields}
						groupBy={effectiveGroupBy}
						onCustomerAction={onCustomerAction}
						loading={loading}
						deleteCustomer={deleteCustomer}
						isFilterView={isFilterView}
						filterViewName={filterViewName}
						customGroupNames={customGroupNames}
						responseGroups={responseGroups}
					/>
				</div>
			);

		default:
			return null;
	}
};
